import { render } from "./ItemTable2.vue?vue&type=template&id=6df6f05b"
import script from "./ItemTable2.vue?vue&type=script&lang=js"
export * from "./ItemTable2.vue?vue&type=script&lang=js"

import "./ItemTable2.vue?vue&type=style&index=0&id=6df6f05b&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__